"use strict";

var EPK = EPK || {};
EPK.Shoho = EPK.Shoho || {};

var args = {
	urlExecute: '',
	urlFinish: '',
	reserveBundleId: '',
	reserveIds: [],
	pharmacyId: '',
	memberFlag: '',
	pastReserveStatus: '',
	optinMailmag: ''
}
EPK.Shoho.ARG = EPK.Shoho.ARG || args;

EPK.Shoho.Reserve = function(urlExecute, urlFinish, reserveBundleId, reserveIds, pharmacyId, memberFlag, pastReserveStatus, optinMailmag) {
	this.urlExecute = urlExecute;
	this.urlFinish = urlFinish;
	this.reserveBundleId = reserveBundleId;
	this.reserveIds = reserveIds;
	this.pharmacyId = pharmacyId;
	this.memberFlag = memberFlag;
	this.executeFlag = true;
	this.pastReserveStatus = pastReserveStatus;
	this.optinMailmag = optinMailmag;
};

EPK.Shoho.Reserve.prototype.execute = function() {
	this.request(this.reserveIds.shift());
};

EPK.Shoho.Reserve.prototype.request = function(elem) {
	if (!elem) {
		// 会員予約でエラーがなければ会員情報連携
		if (this.memberFlag && this.executeFlag) {
			this.updateEparkMemberInfo(this.optinMailmag);
		}

		var urlFinish = EPK.Shoho.ARG.urlFinish;
		if (!this.memberFlag && this.executeFlag) {
			urlFinish += '&' + this.pastReserveStatus;
		}

		location.href = urlFinish;
		return;
	}
	var _this = this;
	this.changeStatus(elem.personType , 'progress');
	$.ajax({
		type: 'GET',
		url: this.urlExecute,
		cache: false,
		data: {
			reserve_bundle_id: elem.reserveBundleId,
			mw_reserve_id: elem.mwReserveId,
			person_type: elem.personType
		}
	})
	.done(function(data) {
		_this.changeStatus(elem.personType , 'complete');
		_this.request(_this.reserveIds.shift());
	})
	.fail(function(data) {
		_this.changeStatus(elem.personType , 'error');
		_this.request(_this.reserveIds.shift());
	});
};

EPK.Shoho.Reserve.prototype.changeStatus = function(person_type  , status) {
	var elemPerson = $('#' + person_type);
	var elemStatus = $('#' + person_type).find('.status');
	var elemStatusLabel = $('#' + person_type).find('.status_label');
	var loading = $('#' + person_type).find('.shoho_loading');

	switch (status) {
	case 'error':
		elemStatus.text('が送信エラー');
		elemStatusLabel.addClass('error');
		elemStatusLabel.removeClass('processed');
		loading.find('img').remove(0);
		this.executeFlag = false;
		break;
	case 'progress':
		elemStatus.text('を送信中');
		elemStatusLabel.addClass('processed');
		elemStatusLabel.removeClass('wait');
		break;
	case 'complete':
		elemStatus.text('を送信完了');
		elemStatusLabel.addClass('complete');
		elemStatusLabel.removeClass('processed');
		loading.find('img').remove(0);
		break;
}
};

EPK.Shoho.Reserve.prototype.redirect = function() {
	var url = this.urlFinish + '?reserve_bundle_id=' + this.reserveBundleId + '&pharmacy_id=' + this.pharmacyId;
	$(location).attr('href', url);
};

EPK.Shoho.Reserve.prototype.updateEparkMemberInfo = function(optinMailmag) {
	// optinMailmag == 2 は実行しない
	if (optinMailmag != 2) {
		var url = '/api/member/update/shoho_optin';
		$.ajax({
			type: 'GET',
			url: url,
			data: {optin: optinMailmag},
			cache: false
		});
	}
};

EPK.Uploader = EPK.Uploader || {};
EPK.Uploader.uploadResult = true;
EPK.Uploader.uploadResultMessage = '';

EPK.Uploader.bindPreviewEvent = function() {
	$('.btn-showPreviewImage').on('click', function(event) {
		var $target = $(this);
		var shopId = $target.data('shop-id');
		var personType = $target.data('person-type');
		var imageIndex = $target.data('image-index');
		var $messageArea = $('.image-check-box.' + personType);
		$messageArea.find('.js-error-message').remove();
		$('.error-message.'+personType).remove();

		// file form に値が残っていたら、アップロードする。
		EPK.Uploader.upload(personType, imageIndex);
		if (EPK.Uploader.uploadResult === false ) {
			var errorMessagePrefix = '';
			$.each(EPK.Shoho.PersonTypes, function(i, el) {
				if (el.id == personType) {
					errorMessagePrefix += el.label_shoho + 'の';
					return false;
				}
			})
			errorMessagePrefix += (imageIndex + 1) + '枚目の';
			$messageArea.prepend($('<div>').addClass('js-error-message'));
			var $targetElement = $messageArea.find('.js-error-message');
			if (EPK.Uploader.uploadResultMessage instanceof Object) {
				$.each(EPK.Uploader.uploadResultMessage, function(i, e) {
					$targetElement.append($('<div>').addClass('error-message').append(errorMessagePrefix + e));
				});
			} else {
				$targetElement.append($('<div>').addClass('error-message').append(errorMessagePrefix + EPK.Uploader.uploadResultMessage));
			}

			EPK.Uploader.deleteImage(personType, imageIndex);
			EPK.Uploader.checkSubmitBtn();

			// 次のアップロードに備えて結果をtrueにしておく。
			EPK.Uploader.uploadResult = true;
			EPK.Uploader.uploadResultMessage = '';
			return;
		}

		// アップロード完了したら、preview リンクを表示する。
		var preview_link = '/shoho/image?pharmacy_id='+shopId+'&person_type='+personType+'&index='+imageIndex+"&ver="+new Date().getTime();
		var args = {person_type: personType, index: imageIndex, preview_link: preview_link, shop_id: shopId};
		var rendered = $('#modalImagePreview').render(args);
		var elem = $(rendered);
		$('body').prepend(elem);

		EPK.Uploader.bindPreviewClose();
		EPK.Uploader.bindDeleteEvent();
	});
};

EPK.Uploader.bindPreviewClose = function() {
	$(".btn-closePreview").on("click",function(event){
		$(event.target).parents().find(".modalPreviewImage").remove(0);
	});
};

EPK.Uploader.bindDeleteEvent = function() {
	$(".btn-deleteImage").on("click",function(event){
		var $target = $(this);
		var shopId = $target.data("shop-id");
		var personType = $target.data("person-type");
		var imageIndex = $target.data("image-index");

		$.ajax({
			async: false,
			type: "GET",
			url: "/shoho/image?command=delete",
			cache: false,
			timeout: 20000,
			data: {
				pharmacy_id: shopId,
				person_type: personType,
				index: imageIndex,
			}
		}).done(function(data, textStatus, jqXHR){
			EPK.Uploader.afterImageDeleted(personType, imageIndex);
		}).fail(function(jqXHR, textStatus, errorThrown){
			console.log(errorThrown);
		});
	});
};

EPK.Uploader.upload = function(personType,index) {
	var $fileForm = $("#"+ personType + "-" + index + "-picture");
	if (personType == 'self01hospital'){
		var child_name = 'child_member_no_self01shoho';
	}else{
		var child_name = 'child_member_no_' + personType;
	}
	var family_no = $('[name= ' + child_name + ']').val();
	var uploadUrl = $fileForm.data("upload-url");
	if ( !uploadUrl ) {
		console.log("confirm page");
		return;
	}
	var uploadUrl = $fileForm.data("upload-url") + '&family_no=' + family_no;

	if ( $fileForm.prop("files").length == 0 ) {
		return true;
	}

	var formData = new FormData();
	formData.append($fileForm.prop("name"),$fileForm.prop("files")[0]);
	var postData = {
		async: false,
		type : "POST",
		dataType : "json",
		data : formData,
		processData : false,
		contentType : false,
		context: $fileForm
	};
	$.ajax(uploadUrl, postData)
		.done(function(data, textStatus, jqXHR){
			$(this).val("");
			EPK.Uploader.uploadResult = data.result;
			EPK.Uploader.uploadResultMessage = data.error_message;
		})
		.fail(function(jqXHR, textStatus, errorThrown){
			console.log(errorThrown);
			EPK.Uploader.uploadResult = false;
			EPK.Uploader.uploadResultMessage = "アップロード中にサーバーエラーが発生しました。";
		});
};

EPK.Uploader.initEvents = function() {
	$('.form-file').on('change', function() {
		var personType = $(this).data('person-type');
		var index = $(this).data('image-index');

		if ($('#' + personType + '-' + index + '-picture').val().length > 0) {
			EPK.Uploader.addImage(personType, index);
			EPK.Uploader.checkSubmitBtn();
		}
	});
};

EPK.Uploader.addImage = function(personType, index) {
	EPK.Uploader.upload(personType,index);

	var $thumnail_box = $('#fileup-btn-' + personType);
	var $thumnail = $($thumnail_box.find('a')[index]);
	var $thumnail_label = $('.label-' + personType);

	$thumnail.data('image-uploaded', 1);

	// 画像追加ボタン表示対象
	var targetIndex = 0;
	$.each($thumnail_box.find('a'), function(i, el) {
		if ($(el).data('image-uploaded') == 0) {
			targetIndex = $(el).data('image-index');
			return false;
		}
	});

	// 初期画像追加ボタンの非表示
	$('.label-' + personType).closest('li').hide();
	// 画像追加ボタン
	var label_name = "[class^='label-" + personType + "']";
	var $fileupBtn = $thumnail_box.find(label_name);
	if (targetIndex == 0) {
		// 画像追加ボタン非表示
		$fileupBtn.closest('li').hide();
	} else {
		// 画像追加ボタンのproperties変更
		$fileupBtn.prop('for', personType + '-' + targetIndex + '-picture');
		$fileupBtn.closest('li').css('display', 'inline-block');

		var viewThmCount = 1;
		$.each($thumnail_box.find('.thm'), function(i, el) {
			if ($(el).css('display') != 'none') {
				viewThmCount++;
			}
		});
		$fileupBtn.removeClass();
		$fileupBtn.addClass('label-' + personType + '-' + (viewThmCount + 1));
	}

	// サムネイル表示
	$thumnail.closest('li').css('display', 'inline-block');
	// サムネイル枠表示
	$thumnail_box.show();
	if($('#shown_thumbnail_images_count').length > 0){
		shownThumbnailImagesCounter.increaseShownImagesCount(personType);
	}
};

EPK.Uploader.deleteImage = function(personType, index) {
	var $thumnail_box = $('#fileup-btn-' + personType);
	var $thumnail = $($thumnail_box.find('a')[index]);
	var $thumnail_label = $('.label-' + personType);
	$thumnail.data('image-uploaded', 0);

	// 画像追加ボタン対象
	var targetIndex = 0;
	$.each($thumnail_box.find('a'), function(i, el) {
		if ($(el).data('image-uploaded') == 0) {
			targetIndex = $(el).data('image-index');
			return false;
		}
	});

	// サムネイル表示
	$thumnail.closest('li').hide();

	var viewThmCount = 0;
	$.each($thumnail_box.find('.thm'), function(i, el) {
		if ($(el).css('display') != 'none') {
			viewThmCount++;
		}
	});

	if (viewThmCount == 0 && EPK.Uploader.uploadResult) {
		// 下段の画像追加ボタン表示
		$thumnail_label.closest('li').show();
	}

	// 画像追加ボタン
	var $fileupBtn = $thumnail_box.find('label');
	// 画像追加ボタンのproperties変更
	$fileupBtn.prop('for', personType + '-' + targetIndex + '-picture');
	$fileupBtn.removeClass();
	$fileupBtn.addClass('label-' + personType + '-' + (viewThmCount + 1));
	if (viewThmCount == 0 && EPK.Uploader.uploadResult) {
		$fileupBtn.closest('li').hide();
	}else{
			// 画像追加ボタン表示
		$fileupBtn.closest('li').show();
	}
};

EPK.Uploader.checkSubmitBtn = function() {
	var ableConfirmText = location.pathname == '/shoho/resend' ? '確認画面へ進む' : '上記に同意して進む';

	var disabled = false;

	if (EPK.common.action === 'resend') {
		if ($('.btn-showPreviewImage:visible').length == 0) {
			disabled = true;
		}
	} else {
		if ($('.label-self01shoho').closest('li').css('display') != 'none' && $('.label-self01hospital').closest('li').css('display') != 'none'){
			disabled = true;
		}else if ($('#patientselect-box-family01shoho').length != 0 && $('#patientselect-box-family01shoho').css('display') != 'none'&& $('.label-family01shoho').length != 0 && $('.label-family01shoho').closest('li').css('display') != 'none'){
			disabled = true;
		}else if ($('#patientselect-box-family02shoho').length != 0 && $('#patientselect-box-family02shoho').css('display') != 'none'&& $('.label-family02shoho').length != 0 && $('.label-family02shoho').closest('li').css('display') != 'none'){
			disabled = true;
		}
	}

	if (disabled){
		$('#confirm-btn').prop('disabled', true);
		$('#confirm-btn').val('登録した画像は0枚です');
	}else{
		$('#confirm-btn').prop('disabled', false);
		$('#confirm-btn').val(ableConfirmText);
	}
}

EPK.Uploader.afterImageDeleted = function(personType, index) {
	var $modal = $("#modal-" + personType + "-" + index);

	EPK.Uploader.deleteImage(personType, index);
	EPK.Uploader.checkSubmitBtn();
	$modal.remove(0);

	if($('#shown_thumbnail_images_count').length > 0){
		shownThumbnailImagesCounter.decreaseShownImagesCount(personType);
	}
}

EPK.Shoho.Action = EPK.Shoho.Action || {};
EPK.Shoho.Action.Index = EPK.Shoho.Action.Index || {};
EPK.Shoho.Action.Finish = EPK.Shoho.Action.Finish || {};

/* Action.Index */
EPK.Shoho.Action.Index.initialize = function() {
	EPK.Shoho.Action.Index.$confirmAnchor = $('#confirm-anchor');
	EPK.Shoho.Action.Index.$confirmAlertPopupBtn = $('.terms input[type=button]');

	EPK.Shoho.Action.Index.initEvents();

	$('span.epark-member-text').eq(0).text('（EPARK会員の方）');

	var $textarea = $('#res-freetext');
	var $count = $('.res-count-text');
	if ($textarea.length > 0) {
		if ($textarea.val().replace(/\s+/g,'').length > 200) {
			$count.addClass('over-text');
		}
	}

	EPK.Shoho.Popup.bindEvents();

	// クーポンフィールドの非同期取得
	$.ajax({
		url: '/shoho/getPointField',
		type: 'POST',
		data: {
			'shop_id': EPK.Shoho.ARG.pharmacyId,
			'selected_coupon': EPK.Shoho.selectedCoupon,
			'error_coupon_list': EPK.Shoho.errorCouponList
		},
		dataType: 'HTML'
	})
	.done(function(data) {
		$('.use-ptcpn').append(data);
	})
	.always(function() {
		if ($('.use-ptcpn').find('h2').length == 0) {
			$('.use-ptcpn').remove();
		}
	});
};

EPK.Shoho.Action.Index.initEvents = function() {
	// Alert Popup
	EPK.Shoho.Action.Index.$confirmAlertPopupBtn.on('click', function() {
		if ($(this).hasClass('is-popup')) {
			EPK.Shoho.Action.Index.$confirmAnchor.trigger('click');
			return;
		} else if ($(this).prop('disabled')) {
			return;
		}

		$(this).prop('disabled', true);

		dataLayer.push({'event': 'formnext','action': '予約フォーム内ボタン','category': 1,'label': EPK.Shoho.ARG.pharmacyId});
		$('#form-input').submit();
	});

	/**
	 * Simple Payment
	 */
	var Payment = new EPK.Shoho.Payment();
	Payment.initEvents();

	/**
	 * Text Counter
	 */
	var $textarea = $('#res-freetext');
	var $count = $('.res-count-text');
	var thisValueLength = '';
	if ($textarea.length > 0) {
		$textarea.bind('keydown keyup keypress change paste',function() {
			thisValueLength = $textarea.val().replace(/\s+/g,'').length;
			$count.text(thisValueLength);
			if (thisValueLength > 200) {
				$count.addClass('over-text');
			} else {
				$count.removeClass('over-text');
			}
		});

		thisValueLength = $textarea.val().replace(/\s+/g,'').length;
		$count.text(thisValueLength);
	}

	// お客様情報ラジオボタン制御
	$('input[name="user_select"]:radio').on('change', function() {
		if ($(this).val() == 1) {
			$('.form-inline').hide();
		} else if ($(this).val() == 2) {
			$('.form-inline').show();
		}
	});

	// お客様情報ラジオボタンでの制御
	$('input[name="user_select"]:radio').on('change', function() {
		if ($(this).val() == 1) {
			$('.guest-fillter').hide();
		} else {
			$('.guest-fillter').show();
			$('#pay-0').trigger('click');
		}
	});
}

/* Action.Finish */
EPK.Shoho.Action.Finish.initialize = function() {
	EPK.Shoho.Action.Finish.initEvents();

	$('.res-copy-area').focus(function() {
		$(this).select();
	})
	.click(function(){
		$(this).select();
		return false;
	});
};

EPK.Shoho.Action.Finish.initEvents = function() {
	$('#parking-picture').on('click', function() {
		EPK.Shoho.Popup.parkingPhoto();
	});
};

EPK.Shoho.Payment = function() {
	this.isLoad = false;
	this.status = 0;	// 0:初期 1:取得成功 2:取得エラー 3:未登録 4:想定外エラー

	EPK.Shoho.Payment.$cardChangeBtn = $('.res-card-change-btn');
	EPK.Shoho.Payment.$cardError = $('.res-card-error');
	EPK.Shoho.Payment.$creditBox = $('.res-credit-box');
	EPK.Shoho.Payment.$creditBoxText = $('.res-credit-box-text');
	EPK.Shoho.Payment.$creditBtnSub = $('.res-ceredit-btn-sub');
	EPK.Shoho.Payment.$creditCheck = $('.credit-box');
	EPK.Shoho.Payment.$creditInfo = $('#credit-info');
	EPK.Shoho.Payment.$creditLoading = $('#credit-loading');
	EPK.Shoho.Payment.$sendCreditcard = $('.res-send-creditcard');
	EPK.Shoho.Payment.$creditValueNumber = $('#credit-number');
	EPK.Shoho.Payment.$creditValueType = $('#credit-type');
	EPK.Shoho.Payment.$creditValueDate = $('#credit-date');
	EPK.Shoho.Payment.$creditValueNumberHdn = $('input[name="credit-number"]');
	EPK.Shoho.Payment.$creditValueTypeHdn = $('input[name="credit-type"]');
	EPK.Shoho.Payment.$creditValueDateHdn = $('input[name="credit-date"]');
}

EPK.Shoho.Payment.prototype.getCardInformation = function() {
	var _this = this;

	if (this.isLoad) {
		EPK.Shoho.Payment.$creditCheck.show();
	} else {
		EPK.Shoho.Payment.$creditInfo.hide();
		EPK.Shoho.Payment.$creditBoxText.hide();
		EPK.Shoho.Payment.$sendCreditcard.hide();
		EPK.Shoho.Payment.$cardChangeBtn.hide();
		EPK.Shoho.Payment.$creditBtnSub.hide();
		EPK.Shoho.Payment.$cardError.hide();
		EPK.Shoho.Payment.$creditCheck.show();
		EPK.Shoho.Payment.$creditLoading.show();

		this.executeAjax();
	}
}

EPK.Shoho.Payment.prototype.executeAjax = function() {
	var _this = this
	var url = '/api/shoho/getCardInfo';

	$.ajax({
		url: url,
		type: 'GET',
		data: {'shop_id': EPK.Shoho.ARG.pharmacyId},
		dataType : 'json',
		cache: false
	})
	.done(function(data, textStatus, jqXHR) {
		EPK.Shoho.Payment.$creditLoading.hide();

		if (data.status == 0 || data.status == 2) {
			// クレカ情報取得成功
			$.each(data, function(key, val) {
				if ($.isPlainObject(val)) {
					$.each(val, function(key2, val2) {
						if (key2 == 'cardNumber') {
							EPK.Shoho.Payment.$creditValueNumber.html(val2);
						} else if (key2 == 'cardType') {
							EPK.Shoho.Payment.$creditValueType.html(val2);
						} else if (key2 == 'expireDate') {
							EPK.Shoho.Payment.$creditValueDate.html(val2.slice(0, 2) + '/' + val2.slice(2));
						}
					});
				}
			});

			if (data.status == 2) {
				EPK.Shoho.Payment.$creditBox.addClass('credit-info-error');
				EPK.Shoho.Payment.$creditBoxText.text(EPK.Shoho.cardTypesDiscription + '以外はご利用になれません');
				EPK.Shoho.Payment.$creditBox.show();
				EPK.Shoho.Payment.$creditBoxText.show();
			}

			EPK.Shoho.Payment.$creditInfo.show();
			EPK.Shoho.Payment.$cardChangeBtn.show();
			EPK.Shoho.Payment.$creditBtnSub.show();

			_this.status = 1;
		} else {
			if (data.errors.code == 1009) {
				// クレカ情報未登録
				EPK.Shoho.Payment.$creditBoxText.text('クレジットカードが登録されていません。');
				EPK.Shoho.Payment.$creditBoxText.show();
				EPK.Shoho.Payment.$sendCreditcard.show();
				EPK.Shoho.Payment.$creditBtnSub.show();

				_this.status = 3;
			} else {
				EPK.Shoho.Payment.$cardError.show();
				EPK.Shoho.Payment.$creditInfo.show();

				_this.status = 2;

				EPK.Payment.credit.error(data, '.res-card-error-text');
			}
		}
	})
	.fail(function(data) {
		EPK.Shoho.Payment.$creditLoading.hide();
		$('.res-card-error-text').text('カード情報を取得できませんでした');
		EPK.Shoho.Payment.$cardError.show();
		EPK.Shoho.Payment.$creditInfo.show();
		console.log('get credit card information failed');

		_this.status = 4;
	})
	.always(function() {
		_this.isLoad = true;

		if (_this.status == 1) {
			EPK.Shoho.Payment.$creditValueNumberHdn.val(EPK.Shoho.Payment.$creditValueNumber.text());
			EPK.Shoho.Payment.$creditValueTypeHdn.val(EPK.Shoho.Payment.$creditValueType.text());
			EPK.Shoho.Payment.$creditValueDateHdn.val(EPK.Shoho.Payment.$creditValueDate.text());
		} else if (_this.status == 3) {
			EPK.Shoho.Payment.$creditValueNumberHdn.val('unregister');
			EPK.Shoho.Payment.$creditValueTypeHdn.val('unregister');
			EPK.Shoho.Payment.$creditValueDateHdn.val('unregister');
		} else {
			EPK.Shoho.Payment.$creditValueNumberHdn.val('error');
			EPK.Shoho.Payment.$creditValueTypeHdn.val('error');
			EPK.Shoho.Payment.$creditValueDateHdn.val('error');
		}
	});
}

EPK.Shoho.Payment.prototype.initEvents = function() {
	var _this = this;

	// #16545
	var $CardType = $('.card-type');

	if ($('input[name="pay"]:checked').val() == 1) {
		$('.cash-box').hide();
		$('.pay-0-notice').hide();
		$('.pay-1-notice').show();
		_this.getCardInformation();
	}

	if (EPK.Shoho.cardTypes) {
		// $('#pay-1').parent().append($('.card-type'));
		$CardType.css('display', '');
	}

	$('input[name="pay"]:radio').on('change', function() {
		if ($(this).val() == 1) {
			// クレカ情報取得
			_this.getCardInformation();
			//$CardType.hide();
		} else if ($(this).val() == 2) {
			EPK.Shoho.Payment.$creditCheck.show();
			// $CardType.show();
		} else {
			EPK.Shoho.Payment.$creditCheck.hide();
			// $CardType.show();
		}

		// ラジオボタンのチェックでテキストを出す
		if ($('input[type=radio][name=pay]').prop('checked')) {
			$('.cash-box').show();
			$('.pay-0-notice').show();
			$('.pay-1-notice').hide();
		} else {
			$('.cash-box').hide();
			$('.pay-0-notice').hide();
			$('.pay-1-notice').show();
		}
	});

	// retry get credit card information
	$('.res-card-error-btn').on('click', function() {
		_this.isLoad = false;
		_this.getCardInformation();
	});

	// popup
	$('#credit-popup').on('click', function() {
		//$('#modal-credit-popup').trigger('click');
		if ($(this).hasClass('is-active')) {
			$(this).removeClass('is-active');
		} else {
			$(this).addClass('is-active');
		}
	});
	$('span.batu').on('click',function () {
		if ($('#credit-popup').hasClass('is-active')) {
			$('#credit-popup').removeClass('is-active')
		}
	})

	// Change Credit Card
	$('.change-credit-btn').off().on('click', function() {
		var $form = $('#form-input');
		var url = $('.res-card-change-btn').children('.change-credit-btn').data('url');
		$form.prop('action', url).submit();
	});
};

EPK.Shoho.Coupon = function(apiErrorFlag) {
	this.apiErrorFlag = apiErrorFlag;

	this.hasPoint = parseInt($('.use-pt').find('b').text().replace(',',''));
	this.availablePoint = this.hasPoint;
	this.$usePoint = $('.use-pt').find('b');
	this.$usedPoint = $('.used-pt').find('b');
	this.$pointShortageModalAvailablePoint = $('#modal-available-pt dd b');
	this.$pointShortageModalNowPoint = $('#modal-now-pt dd b');
	this.$pointShortageModalCalcPoint = $('#modal-calc-pt dd b');
}

EPK.Shoho.Coupon.prototype.init = function() {
	this.initEvent();
	this.initView();

	// クーポンが選択されている場合はポップアップ内にメッセージ追加
	if ($('.coupon-slide:checked').length > 0) {
		this.addPopupClass();
	}
}

EPK.Shoho.Coupon.prototype.initEvent = function() {
	var _this = this;
	// クーポン詳細ポップアップ
	$('.modal-coupon-btn').on('click', function() {
		var target = $(this).data('target');
		_this.openPopup(target);
	});

	// クーポン選択
	$('.coupon-slide').on('change', function() {
		// #22286 add
		_this.availablePoint = 0;

		var point = parseInt($(this).data('point'));
		var remainingPoint = _this.availablePoint - point;

		if ($(this).prop('checked')) {
			if (remainingPoint >= 0) {
				// 無料クーポンは何もしない
				if (remainingPoint > 0) {
					// 利用可能ポイントから減算
					_this.availablePoint -= point;
					_this.$usedPoint.text(_this.numSeparate(_this.availablePoint));
					_this.$pointShortageModalNowPoint.text(_this.numSeparate(_this.hasPoint - _this.availablePoint));
				}
			} else {
				$(this).prop('checked', false);
				if (_this.apiErrorFlag) {
					_this.openPopup('#modal-coupon-point-acquisition-error');
				} else {
					_this.$pointShortageModalCalcPoint.text('-' + _this.numSeparate(point - _this.availablePoint));
					_this.openPopup('#modal-coupon-point-shortage');
				}
			}
		} else {
			// 利用可能ポイントに加算
			_this.availablePoint += point;
			_this.$usedPoint.text(_this.numSeparate(_this.availablePoint));
			_this.$pointShortageModalNowPoint.text(_this.numSeparate(_this.hasPoint - _this.availablePoint));
		}

		// クーポンが選択されている場合はポップアップ内にメッセージ追加
		if ($('.coupon-slide:checked').length > 0) {
			_this.addPopupClass();
		} else {
			_this.removePopupClass();
		}
	});
}

EPK.Shoho.Coupon.prototype.initView = function() {
	var _this = this;
	var errorPoint = '- ';

	if (!this.apiErrorFlag) {
		// 選択済みのクーポンのポイントを減算
		$.each($('.coupon-slide'), function(i, e) {
			if ($(this).prop('checked')) {
				_this.availablePoint -= parseInt($(this).data('point'));
			}
		});

		// EPARKポイント初期表示
		this.$usedPoint.text(this.numSeparate(this.availablePoint));
		this.$pointShortageModalNowPoint.text(0);

		if (errorPoint == this.$usePoint.text()) {
			this.$usePoint.text(this.numSeparate(this.availablePoint));
			this.$pointShortageModalAvailablePoint.text(this.numSeparate(this.availablePoint));
		}
	} else {
		this.$usePoint.text(errorPoint);
		this.$usedPoint.text(errorPoint);
	}
}

EPK.Shoho.Coupon.prototype.numSeparate = function(num) {
	num = String(num);

	var strMinus = '';
	if (num.indexOf('-') > -1) {
		strMinus = '-';
	}

	num = num.replace(/-/g, '');
	var len = num.length;

	if (len > 3) {
		// 前半を引数に再帰呼び出し + 後半3桁
		return strMinus + this.numSeparate(num.substring(0, len - 3)) + ',' + num.substring(len - 3);
	} else {
		return strMinus + num;
	}
}

EPK.Shoho.Coupon.prototype.openPopup = function(src) {
	$.magnificPopup.close();
	$.magnificPopup.open({
		items: {src: src},
		type: 'inline',
		modal: true,
	}, 0);
}

EPK.Shoho.Coupon.prototype.addPopupClass = function() {
	$('#confirm-btn').addClass('is-popup');
}

EPK.Shoho.Coupon.prototype.removePopupClass = function() {
	$('#confirm-btn').removeClass('is-popup');
}

EPK.Shoho.Coupon.prototype.createCouponSwiper = function() {
	$('.slide-ptcpn').swiper({
		centeredSlides: false,
		slidesPerView: 4,
		spaceBetween: 11,
		loop: false,
		pagination: '.swiper-pagination',
		nextButton: '.swiper-button-next',
		prevButton: '.swiper-button-prev'
	});
}

//===================
//ポップアップ送信
//===================
EPK.Shoho = EPK.Shoho || {};
EPK.Shoho.Popup = EPK.Shoho.Popup || {};
EPK.Shoho.Popup.selectedDateIndex = null;
EPK.Shoho.Popup.selectedHour = null;
EPK.Shoho.Popup.selectedMinute = null;
EPK.Shoho.Popup.selectedDatetime = null;

EPK.Shoho.Popup.$btnSelectTime = $('#btn-popup1_setelet_time');
EPK.Shoho.Popup.$btnSubmitSoon = $('#btn-popup1_soon');
EPK.Shoho.Popup.$btnSelectDate = $('.date-selection');
EPK.Shoho.Popup.$lblSelectedDate = $('#popup3-selected-date');
EPK.Shoho.Popup.$lblSelectedWeekday = $('#popup3-selected-weekday');
EPK.Shoho.Popup.$btnSubmitDatetime = $('#btn-popup3_submit_datetime');
EPK.Shoho.Popup.$btnReturn2 = $('#btn-return-to-popup2');
EPK.Shoho.Popup.$btnReturn1 = $('#btn-return-to-popup1');
EPK.Shoho.Popup.$selectHour = $('#select-popup3_hour');
EPK.Shoho.Popup.$selectMinute = $('#select-popup3_minute');
EPK.Shoho.Popup.$lblError = $('#lbl-dayerror');
EPK.Shoho.Popup.$daySelections = $('#ul-day_selections');
EPK.Shoho.Popup.$deliveryDate = $('#delivery_date');
EPK.Shoho.openTimes = EPK.Shoho.openTimes || {};
EPK.Shoho.openTimes['validTimes'] = {};
EPK.Shoho.openTimes['validFlag'] = [];
EPK.Shoho.openTimes['lastTimes'] = [];

EPK.Shoho.Popup.$inputReceiveTime = $('#receive-time');
EPK.Shoho.Popup.$inputReceiveTimeHidden = $('#receive-time-hidden');

EPK.Shoho.Popup.popupIds = [
	'#modal-credit',
	'#modal-credit-day',
	'#modal-credit-time',
	'#modal-latest-shoho-reserve',
];
EPK.Shoho.Popup.initParkingModalSwiper = function() {
	var swiper = $('#parking-img').swiper({
		slidesPerView: 'auto',
		centeredSlides: false,
		preloadImages: true,
		lazyLoading: true,
		lazyLoadingInPrevNext: true,
	});
};

EPK.Shoho.Popup.parkingPhoto = function () {
	$.magnificPopup.close();
	$.magnificPopup.open({
		items: {src: '#modal-parking-picture'},
		type: 'inline',
		modal: true
	}, 0);
	EPK.Shoho.Popup.initParkingModalSwiper();
};
/**
*
*/
EPK.Shoho.Popup.defaultHours = [];
for (var index=0; index <= 23; index++){
	EPK.Shoho.Popup.defaultHours.push(index);
}
EPK.Shoho.Popup.defaultMinutes = [
	0, 15, 30, 45
];

EPK.Shoho.Popup.open = function(index){
	$.magnificPopup.close();
	$.magnificPopup.open({
		items: {src: EPK.Shoho.Popup.popupIds[index]},
		type: 'inline',
		modal: true,
	}, 0);
};

EPK.Shoho.Popup.initDatetimeArgs = function(){
	EPK.Shoho.openTimes['days'].forEach(function(day, index){
		var valid_date_flag = false;
		var opentimes = EPK.Shoho.openTimes['opentimes'][index];
		EPK.Shoho.openTimes['validTimes'][index] = {};
		EPK.Shoho.openTimes['lastTimes'][index] = [];
		EPK.Shoho.openTimes['lastTimes'][index]['hour'] = null;
		EPK.Shoho.openTimes['lastTimes'][index]['minute'] = null;
		EPK.Shoho.Popup.defaultHours.forEach(function(hour){
			EPK.Shoho.Popup.defaultMinutes.forEach(function(minute){
				if(EPK.Shoho.Popup.validateDate(index, hour, minute)){
					valid_date_flag = true;
					EPK.Shoho.openTimes['validTimes'][index][hour] =
						EPK.Shoho.openTimes['validTimes'][index][hour] || [];
					EPK.Shoho.openTimes['validTimes'][index][hour].push(minute);
				}
			});
		});
		EPK.Shoho.openTimes['validFlag'][index] = valid_date_flag;
		if(!valid_date_flag){
			var $dayselection = EPK.Shoho.Popup.$daySelections.find('li').eq(index);
			$dayselection.find('a').addClass('disabled');
		}

		if (opentimes['open24_flag']) {
			EPK.Shoho.openTimes['lastTimes'][index]['hour'] = 24;
			EPK.Shoho.openTimes['lastTimes'][index]['minute'] = 0;
		} else {
			var openTimeIndexes = [1,2,3];
			openTimeIndexes.forEach(function(i, el) {
				if (opentimes['open_time' + i] && opentimes['close_time' + i]) {
					var open = new Date(opentimes['open_time' + i].split('+')[0]);
					var close = new Date(opentimes['close_time' + i].split('+')[0]);

					var formated = EPK.Shoho.Popup.formatDate(close, 'hh:mm').split(':');
					if (formated[0] != formated[1]) {
						EPK.Shoho.openTimes['lastTimes'][index]['hour'] = parseInt(formated[0]);
						EPK.Shoho.openTimes['lastTimes'][index]['minute'] = parseInt(formated[1]);
					}
				}
			});
		}
	});
};

EPK.Shoho.Popup.initDatetimePopup = function(){
	EPK.Shoho.Popup.$lblError.hide();
	EPK.Shoho.Popup.bindEvents();
	EPK.Shoho.Popup.open(0);
	EPK.Shoho.Popup.initDatetimeArgs();
};

EPK.Shoho.Popup.submitSoon = function(){
	var date = new Date();
	var minute = date.getMinutes() + 16;
	var hour = date.getHours();
	if(EPK.Shoho.Popup.validateDate(0, hour, minute)){
		$.magnificPopup.close();
		EPK.Shoho.Popup.selectDatetimeCallback(0);

		// 必須項目残り数
		var result = EPK.Shoho.FloatRequired.status(1);
		EPK.Shoho.FloatRequired.view();
		EPK.Shoho.FloatRequired.viewError(!result['valid'], 1, result['message']);
	}else{
		alert('15分後は営業時間外です。');
	}
};

EPK.Shoho.Popup.submitWithTime = function(){
	EPK.Shoho.Popup.open(1);
};

EPK.Shoho.Popup.bindEvents = function(){
	EPK.Shoho.Popup.$btnSelectTime.off('click');
	EPK.Shoho.Popup.$btnSelectTime.on('click', function(e){
		e.preventDefault();
		EPK.Shoho.Popup.submitWithTime();
	});
	EPK.Shoho.Popup.$btnSubmitSoon.off('click');
	EPK.Shoho.Popup.$btnSubmitSoon.on('click', function(e){
		e.preventDefault();
		EPK.Shoho.Popup.submitSoon();
	});

	EPK.Shoho.Popup.$selectHour.off('change');
	EPK.Shoho.Popup.$selectHour.on('change', function(){
		var val = $(this).val();
		EPK.Shoho.Popup.$selectMinute.empty();
		var validTimes = EPK.Shoho.openTimes['validTimes'][EPK.Shoho.Popup.selectedDateIndex];
		validTimes[val].forEach(function(minute, index){
			var str = "";
			if(minute == 0 || minute.toString() == "0") {
				str = "00";
			}else {
				str = minute.toString();
			}
			EPK.Shoho.Popup.$selectMinute.append(
				'<option>' + str + '</option>');
		});
		EPK.Shoho.Popup.viewTimeAfterText();
	});

	EPK.Shoho.Popup.$selectMinute.off('change');
	EPK.Shoho.Popup.$selectMinute.on('change', function(){
		EPK.Shoho.Popup.viewTimeAfterText();
	});

	EPK.Shoho.Popup.$btnSelectDate.off('click');
	EPK.Shoho.Popup.$btnSelectDate.on('click', function(e){
		e.preventDefault();
		if($(this).hasClass('disabled')){
			return;
		}
		EPK.Shoho.Popup.selectedDateIndex = $(this).attr('data-index')*1;
		EPK.Shoho.Popup.$lblSelectedDate.text(
			EPK.Shoho.openTimes['day_string_disp'][EPK.Shoho.Popup.selectedDateIndex]
		);
		EPK.Shoho.Popup.$lblSelectedWeekday.text(
			EPK.Shoho.openTimes['weekday_strings'][EPK.Shoho.Popup.selectedDateIndex]
		);
		EPK.Shoho.Popup.$selectHour.empty();
		EPK.Shoho.Popup.$selectMinute.empty();
		var validTimes = EPK.Shoho.openTimes['validTimes'][EPK.Shoho.Popup.selectedDateIndex];
		Object.keys(validTimes).forEach(function(key, index){
			EPK.Shoho.Popup.$selectHour.append(
				'<option>' + key.toString() + '</option>');
			if(index == 0){
				validTimes[key].forEach(function(minute, index){
					var str = "";
					if(minute == 0 || minute.toString() == "0") {
						str = "00";
					}else {
						str = minute.toString();
					}
					EPK.Shoho.Popup.$selectMinute.append(
						'<option>' + str + '</option>');
				});
			}
		});
		EPK.Shoho.Popup.viewTimeAfterText();
		EPK.Shoho.Popup.open(2);
	});

	EPK.Shoho.Popup.$btnSubmitDatetime.off('click');
	EPK.Shoho.Popup.$btnSubmitDatetime.on('click', function(e){
		e.preventDefault();
		EPK.Shoho.Popup.selectedHour = EPK.Shoho.Popup.$selectHour.val();
		EPK.Shoho.Popup.selectedMinute = EPK.Shoho.Popup.$selectMinute.val();
		EPK.Shoho.Popup.selectedDatetime = new Date(
			EPK.Shoho.openTimes['years'][EPK.Shoho.Popup.selectedDateIndex],
			EPK.Shoho.openTimes['months'][EPK.Shoho.Popup.selectedDateIndex] - 1,
			EPK.Shoho.openTimes['days'][EPK.Shoho.Popup.selectedDateIndex],
			EPK.Shoho.Popup.selectedHour,
			EPK.Shoho.Popup.selectedMinute
		);

		if(EPK.Shoho.Popup.validateSelectedDate()){
			EPK.Shoho.Popup.selectDatetimeCallback(EPK.Shoho.Popup.selectedDatetime);
			$.magnificPopup.close();

			// 必須項目残り数
			var result = EPK.Shoho.FloatRequired.status(1);
			EPK.Shoho.FloatRequired.view();
			EPK.Shoho.FloatRequired.viewError(!result['valid'], 1, result['message']);
		}else{
			EPK.Shoho.Popup.selectedHour = null;
			EPK.Shoho.Popup.selectedMinute = null;
			EPK.Shoho.Popup.selectedDatetime = null;
		}
	});

	EPK.Shoho.Popup.$btnReturn2.off('click');
	EPK.Shoho.Popup.$btnReturn2.on('click', function(e){
		e.preventDefault();
		EPK.Shoho.Popup.selectedDateIndex = null;
		EPK.Shoho.Popup.open(1);
	});

	EPK.Shoho.Popup.$btnReturn1.off('click');
	EPK.Shoho.Popup.$btnReturn1.on('click', function(e){
		e.preventDefault();
		EPK.Shoho.Popup.open(0);
	});
};

EPK.Shoho.Popup.checkViewTimeAfterText = function() {
	var hour = parseInt(EPK.Shoho.Popup.$selectHour.val());
	var minute = parseInt(EPK.Shoho.Popup.$selectMinute.val());
	var lastTime = EPK.Shoho.openTimes['lastTimes'][EPK.Shoho.Popup.selectedDateIndex];

	return lastTime['hour'] == hour && lastTime['minute'] == minute;
}

EPK.Shoho.Popup.viewTimeAfterText = function() {
	var $afterText = $('#select-popup3_minute_after_text');

	if (EPK.Shoho.Popup.checkViewTimeAfterText()) {
		$afterText.text('');
	} else {
		$afterText.text('以降');
	}
}

/**
* 時間指定時のコールバック
* @param value 今すぐ: 0, その他: 選択日次
*/
EPK.Shoho.Popup.selectDatetimeCallback = function(value){
	var receive_time = '';
	var receive_time_hidden = '';
	if (value == 0) {
		receive_time = '今すぐ（送信後15分目安）';
		receive_time_hidden = '今すぐ（送信後15分目安）';
	} else {
		var formatted_value = EPK.Shoho.Popup.formatDate(value, 'MM/DD（week） hh：mm', false);
		var formatted_value_hidden = EPK.Shoho.Popup.formatDate(value, 'YYYY-MM-DD hh:mm:ss', true);
		if (EPK.Shoho.Popup.checkViewTimeAfterText()) {
			receive_time = formatted_value;
		} else {
			receive_time = formatted_value + ' 以降';
		}
		receive_time_hidden = formatted_value_hidden;
	}
	EPK.Shoho.Popup.$inputReceiveTime.val(receive_time);
	EPK.Shoho.Popup.$inputReceiveTimeHidden.val(receive_time_hidden);
};

EPK.Shoho.Popup.validateSelectedDate = function(){
	var hour = EPK.Shoho.Popup.selectedHour;
	var minute = EPK.Shoho.Popup.selectedMinute;
	var index = EPK.Shoho.Popup.selectedDateIndex;
	return EPK.Shoho.Popup.validateDate(index, hour, minute, true);
};

EPK.Shoho.Popup.validateDate = function(index, hour, minute, show_message_flag){
	var year = EPK.Shoho.openTimes['years'][index];
	var month = EPK.Shoho.openTimes['months'][index];
	var date = EPK.Shoho.openTimes['days'][index];
	var opentimes = EPK.Shoho.openTimes['opentimes'][index];

	var no_immediate_flag = EPK.Shoho.openTimes['no_immediate_flag'] || false;
	var additionalTime = 15 * 60 * 1000; // 現在時刻以降、予約できる最短時間
	if(no_immediate_flag) {
		additionalTime = 30 * 60 * 1000; // #7410対応（予約できる最短時間を30分後にする）
	}

	// #18366 発券機の待ち時間C側対応
	var waiting_time = EPK.Shoho.openTimes['waiting_time'] || 0;
	if (waiting_time > 0) {
		if (waiting_time > 60) waiting_time = 60;	// 待ち時間は60分以上にしない
		additionalTime = waiting_time * 60 * 1000;
	}

	var now = new Date();
	now = now.setTime(now.getTime() + (additionalTime));

	var currentDate = new Date().getDate();
	var currentMonth = new Date().getMonth();

	var selectedDateTime = new Date(year, month - 1, date, hour, minute);
	var selectedTime = selectedDateTime.getTime();

	/**
	 *  php(DB)から渡ってくる営業時間が全て日付が todayになってるので
	 +  営業時間比較用に変数定義
	 */
	var selectedDateTimeComp = new Date(year, currentMonth, currentDate, hour, minute);
	var selectedTimeComp = selectedDateTimeComp.getTime();

	if(selectedTime < now){
		// 過去時間でバリデーション NG
		if(show_message_flag) {
			EPK.Shoho.Popup.errors.throw('PastTime');
		}
		return false;
	} else {
		if(opentimes['open_time1']){
			var open = new Date(opentimes['open_time1'].split('+')[0] + '+09:00').getTime();
			var close = new Date(opentimes['close_time1'].split('+')[0] + '+09:00').getTime();
			if (open <= selectedTimeComp && close >= selectedTimeComp && open !== close){
				return true;
			}
		}
		if(opentimes['open_time2']){
			var open = new Date(opentimes['open_time2'].split('+')[0] + '+09:00').getTime();
			var close = new Date(opentimes['close_time2'].split('+')[0] + '+09:00').getTime();
			if (open <= selectedTimeComp && close >= selectedTimeComp && open !== close) {
				return true;
			}
		}
		if(opentimes['open_time3']) {
			var open = new Date(opentimes['open_time3'].split('+')[0] + '+09:00').getTime();
			var close = new Date(opentimes['close_time3'].split('+')[0] + '+09:00').getTime();
			if (open <= selectedTimeComp && close >= selectedTimeComp && open !== close) {
				return true;
			}
		}
	}
	// 営業時間外でバリデーション NG
	if(show_message_flag){
		EPK.Shoho.Popup.errors.throw('OuterTime');
	}
	return false;
};

EPK.Shoho.Popup.errors = {};
EPK.Shoho.Popup.errors.hide = function(kind){
	EPK.Shoho.Popup.$lblError.text('');
	EPK.Shoho.Popup.$lblError.hide();
};
EPK.Shoho.Popup.errors.throw = function(kind){
	var string = '';
	if(kind==='PastTime'){
		string = '選択している時刻が過去の時刻のため、予約できません。';
	}
	if(kind==='OuterTime'){
		string = '選択している時刻が営業時間外のため、予約できません。';
	}
	EPK.Shoho.Popup.$lblError.text(string);
	EPK.Shoho.Popup.$lblError.show();
};

/**
* 日付をフォーマットする
* @param  {Date}   date     日付
* @param  {String} [format] フォーマット
* @return {String}          フォーマット済み日付
*/
EPK.Shoho.Popup.formatDate = function (date, format, hidden) {
	if (!format) format = 'YYYY-MM-DD hh:mm:ss.SSS';
	var weekArray = ['日', '月', '火', '水', '木', '金', '土'];
	format = format.replace(/YYYY/g, date.getFullYear());
	if (hidden) {
		format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
		format = format.replace(/DD/g, ('0' + date.getDate()).slice(-2));
	} else {
		format = format.replace(/MM/g, (date.getMonth() + 1));
		format = format.replace(/DD/g, (date.getDate()));
	}
	format = format.replace(/hh/g, ('0' + date.getHours()).slice(-2));
	format = format.replace(/mm/g, ('0' + date.getMinutes()).slice(-2));
	format = format.replace(/ss/g, ('0' + date.getSeconds()).slice(-2));
	format = format.replace(/week/g, weekArray[date.getDay()]);

	if (format.match(/S/g)) {
		var milliSeconds = ('00' + date.getMilliseconds()).slice(-3);
		var length = format.match(/S/g).length;
		for (var i = 0; i < length; i++) format = format.replace(/S/, milliSeconds.substring(i, i + 1));
	}
	return format;
};

EPK.Shoho.Popup.latestShohoReserve = function() {
	var $latestShohoReserve = $('#modal-latest-shoho-reserve');

	if ($latestShohoReserve.length == 0) {
		return;
	}

	EPK.Shoho.Popup.open(3);
	$latestShohoReserve.find('.use-btn').find('a').on('click', function() {
		$('[name=category2]').val($('#c_v_2').data('value'));

		if ($('#c_v_4').data('value') > 0) {
			$('[name=category4]').val($('#c_v_4').data('value'));
		}

		if ($('#c_v_5').data('value') > 0) {
			$('[name=category5]').val($('#c_v_5').data('value'));
		}

		if ($('#c_receive_message').data('value')) {
			$('#res-freetext').val($('#c_receive_message').data('value'));
		}

		EPK.Shoho.FloatRequired.initView();
		$.magnificPopup.close();
	});
};

EPK.Shoho.FloatRequired = EPK.Shoho.FloatRequired || {};

/**
 * 初回残必須項目数表示
 */
EPK.Shoho.FloatRequired.initView = function() {
	$.each(EPK.Shoho.FloatRequired.categoryIdList, function(index, el) {
		EPK.Shoho.FloatRequired.status(el)
	});

	EPK.Shoho.FloatRequired.view();
};

/**
 * 残必須項目数表示
 */
EPK.Shoho.FloatRequired.view = function() {
	var validCount = EPK.Shoho.FloatRequired.validCount;
	$.each(EPK.Shoho.FloatRequired.categoryIdList, function(index, el) {
		if (EPK.Shoho.FloatRequired.categoryIdValidList['c'+el]) {
			validCount--;
		}
	});

	$('#float-validate-num').text(EPK.Shoho.toFullWidth(validCount));
};

/**
 * エラーメッセージ表示/非表示
 */
EPK.Shoho.FloatRequired.viewError = function(error, categoryId, message) {
	categoryId = categoryId + '';
	switch (categoryId) {
		case '1':
		case '2':
		case '4':
		case '5':
			var element = $('[name=category' + categoryId + ']');
			element.closest('.input-box').find('.error-message').remove();
			if (error) {
				element.closest('.input-box').append($('<div>', {class: 'error-message'}).text(message));
				element.closest('.input-box').addClass('error');
			} else {
				element.closest('.input-box').removeClass('error');
			}
			break;

		default:
			break;
	}
};

/**
 * 初期化処理
 */
EPK.Shoho.FloatRequired.init = function() {
	EPK.Shoho.FloatRequired.validCount = 5;
	EPK.Shoho.FloatRequired.categoryIdList = [1,2,4,5,6];
	EPK.Shoho.FloatRequired.categoryIdValidList = [];
	EPK.Shoho.FloatRequired.handlingElementList = {
		2: '#category2',
		4: '[name=category4]',
		5: '[name=category5]',
	};

	EPK.Shoho.FloatRequired.initView();

	$.each(EPK.Shoho.FloatRequired.handlingElementList, function(categoryId, selector) {
		// 受取希望時間以外はフォーカスアウトのときにカウンターを増減させる
		$(selector).focusout(function(event) {
			var result = EPK.Shoho.FloatRequired.status(categoryId);
			EPK.Shoho.FloatRequired.view();
			EPK.Shoho.FloatRequired.viewError(!result['valid'], categoryId, result['message']);
		});
	});

	$('input[type="radio"][name="pay"]').on('click',function() {
		var result =  EPK.Shoho.FloatRequired.status(6)
		EPK.Shoho.paymentFlag = result['valid'];
		EPK.Shoho.FloatRequired.view();
		$('#confirm-btn').prop('disabled', false);
		$('#confirm-btn').val('上記に同意して進む');
	})
};

/**
 * 必須項目の入力選択状況
 */
EPK.Shoho.FloatRequired.status = function(categoryId) {
	categoryId = categoryId + '';
	var status = false;
	var el = $('[name=category'+categoryId+']');
	var result;

	switch (categoryId) {
		case '1':	// 受取希望時間
			result = EPK.Shoho.Validate.shopOpenTime(el.val());
			break;

		case '2':	// 電話番号
			result = EPK.Shoho.Validate.tel(el.val());
			break;

		case '4':	// ジェネリック
		case '5':	// お薬手帳
			result = EPK.Shoho.Validate.selectTag(el.val());
			break;

		case '6': //お支払方法
			result = EPK.Shoho.Validate.payment(el);
			break;
		default:
			break;
	}

	EPK.Shoho.FloatRequired.categoryIdValidList['c'+categoryId] = result['valid'];

	return result;
}

/**
 * 半角英数 ⇒ 全角英数 に変換
 */
EPK.Shoho.toFullWidth = function(val) {
    return (val + '').replace(/[A-Za-z0-9!-~]/g, function(s) {
        return String.fromCharCode(s.charCodeAt(0)+0xFEE0);
    });
}

EPK.Shoho.Validate = EPK.Shoho.Validate || {};

/**
 * 電話番号のバリデート
 */
EPK.Shoho.Validate.tel = function(val) {
	var result = [];
	result['message'] = '';
	result['valid'] = false;

	// 必須入力チェック
	if (!val) {
		result['message'] = '入力必須事項です。';
		return result;
	}

	val = val.replace(/[-ー－―‐]/g, '');

	// 文字数チェック
	if (val.length <= 0) {
		result['message'] = '入力必須事項です。';
		return result;
	}

	// 先頭3文字で携帯電話か判定
	if (val.match(/^0(5|7|8|9)0/)) {
		if (!val.match(/^0[5,6,7,8,9]0[0-9]{8}$/i)) {
			result['message'] = '携帯電話番号の桁数が正しくありません。';
		} else {
			result['valid'] = true;
		}
	} else {
		if (!val.match(/^[0-9]{10,11}$/i)) {
			result['message'] = '電話番号の形式が正しくありません。';
		} else {
			result['valid'] = true;
		}
	}

	return result;
};

/**
 * 受取希望時間のバリデート
 */
EPK.Shoho.Validate.shopOpenTime = function(val) {
	var result = [];
	result['message'] = '';
	result['valid'] = false;

	// 必須入力チェック
	if (!val) {
		result['message'] = '入力必須事項です。';
		return result;
	}

	if (val.match(/^今すぐ（送信後15分目安）$/)) {
		// 今すぐ
		result['valid'] = true;
	} else if (val.match(/^(\d{4})-(0[1-9]|1[0-2])-(0[1-9]|[1,2][0-9]|3[0,1]) ([0,1][0-9]|2[0-3]):(0[0-9]|[1-5][0-9]):(0[0-9]|[1-5][0-9])$/)) {
		// yyyy-mm-dd hh:ii:ss
		result['valid'] = true;
	} else {
		result['message'] = 'お薬お受け取り希望日時の形式が正しくありません。';
	}

	return result;
};

/**
 * プルダウンのバリデート
 */
EPK.Shoho.Validate.selectTag = function(val) {
	var result = [];
	result['message'] = '';
	result['valid'] = false;

	// 必須入力チェック
	if (!val) {
		result['message'] = '選択必須事項です。';
		return result;
	}

	// 文字数チェック
	if (val.length <= 0) {
		result['message'] = '選択必須事項です。';
		return result;
	}

	result['valid'] = true;

	return result;
};

/**
 * お支払方法のバリデート
 */
EPK.Shoho.Validate.payment = function(val) {
	var result = [];
	result['message'] = '';
	result['valid'] = false;

	// チェック確認
	var payMethods = val.find('input[type="radio"][name="pay"]');
	var count = 0;
	if (payMethods.length > 0) {
		$.each(payMethods,function (i,el) {
			if ($(el).prop('checked')) {
				count++;
			}
		})
		if (count <= 0) {
			result['message'] = '選択必須事項です。';
			return result;
		}
	}

	result['valid'] = true;
	EPK.Shoho.paymentFlag = true;

	return result;
};
EPK.Shoho.Family = EPK.Shoho.Family || {};
EPK.Shoho.Family.addFamily = function(){
	if (EPK.common.isLogin){
		location.href = '/patient/users?back_url=shoho&person_type';	//	ログイン中は患者選択画面へ遷移
		return;
	}

	//	未ログイン中は、空きコンテナを表示
	for (var index=1; index<$('#max_family_number').val(); index++){
		var target_id = '#patientselect-box-family' + index.toString().padStart(2, '0') + 'shoho';
		if ($(target_id).length && $(target_id).css('display') == 'none'){	//	空きのコンテナ部分有るなら空きコンテナを表示
			$(target_id).show();

			$('#confirm-btn').prop('disabled', true);
		    $('#confirm-btn').val('登録した画像は0枚です');
			break;
		}
	}
	var all_select = true;
	for (index=1; index<$('#max_family_number').val(); index++){
		var target_id = '#patientselect-box-family' + index.toString().padStart(2, '0') + 'shoho';
		if ($(target_id).length && $(target_id).css('display') == 'none'){
			all_select = false;
			break;
		}
	}
	if (all_select){	//	全てのコンテナを表示している時は、「患者追加」ボタンを非表示
		$('.patientadd-btn').hide();
	}
}
EPK.Shoho.Family.imageCheck = function(){
	var all_select = true;
	for (index=1; index<$('#max_family_number').val(); index++){
		var target_id = '#patientselect-box-family' + index.toString().padStart(2, '0') + 'shoho';
		if ($(target_id).length && $(target_id).css('display') == 'none'){	//	IDが有って、非表示のコンテナがあるときは、全て表示していない
			all_select = false;
			break;
		}
	}
	if (all_select){
		$('.patientadd-btn').hide();
	}else{
		$('.patientadd-btn').show();
	}
}
EPK.Shoho.Family.deletePatient = function(shopId, person_type){
	$.ajax({
		type: "GET",
		url: "/shoho/image",
		cache: false,
		timeout: 20000,
		data: {
			pharmacy_id: shopId,
			person_type: person_type,
			command: 'delete_all'
		}
	}).done(function(data, textStatus, jqXHR){
		if($('#shown_thumbnail_images_count').length > 0){
			shownThumbnailImagesCounter.decreaseShownImagesCount(person_type);
		}
		//	
		var $thumnail_box = $('#fileup-btn-' + person_type);
		var $thumnail_label = $('.label-' + person_type);
		$.each($thumnail_box.find('a'), function(i, el) {
			$(el).data('image-uploaded', 0);
			$(el).closest('li').hide();
		});
		$thumnail_label.closest('li').show();
		$('#' + person_type + '_last_name').val('');
		$('#' + person_type + '_first_name').val('');
		// 画像追加ボタン
		var $fileupBtn = $thumnail_box.find('label');
		$fileupBtn.closest('li').hide();
	}).fail(function(jqXHR, textStatus, errorThrown){
	}).always(function() {
		$('#patientselect-box-' + person_type).hide();
		EPK.Uploader.checkSubmitBtn();
		$('.patientadd-btn').show();
	});
}

$(function() {
	if (location.pathname == '/shoho/prescription') {
		if ($('.patientselect-box:visible').length >= 3) {
			$('.patientadd-btn').hide();
		}
		// submit btn
		$('#confirm-btn').on('click', function() {
			if ($(this).prop('disabled')) {
				return;
			} else if ($(this).hasClass('is-popup')) {
				return;
			}

			$(this).prop('disabled', true);

			dataLayer.push({'event': 'formnext','action': '予約フォーム内ボタン','category': 1,'label': EPK.Shoho.ARG.pharmacyId});
			$('#form-input').submit();
		});
	}

	if (location.pathname == '/shoho') {
		EPK.Shoho.Action.Index.initialize();
		// ポップアップ初期化
		EPK.Shoho.Popup.$inputReceiveTime.on('click', function() {
			EPK.Shoho.Popup.initDatetimePopup();
		});
		// 前回の予約情報ポップアップ表示
		EPK.Shoho.Popup.latestShohoReserve();
		// 残必須項目数表示
		EPK.Shoho.FloatRequired.init();

		// 支払方法 店頭支払い が存在するか
		var isStorePayment = false;
		if ($('#pay-0').length && $('label[for="pay-0"]').is(':visible')) {
			isStorePayment = true;
			EPK.Payment.credit.onStorePaymentButtonClick('label[for="pay-0"]');
		}

		EPK.Payment.credit.setModalStorePaymentButtonVisibility(isStorePayment);
	}

	if (location.pathname == '/shoho/prescription'
		|| location.pathname == '/shoho/retry'
		|| location.pathname == '/shoho/resend'
	) {
		EPK.Uploader.initEvents();
		EPK.Uploader.checkSubmitBtn();
		EPK.Uploader.bindPreviewEvent();
	}

	if (location.pathname == '/shoho/confirm'
		|| location.pathname == '/shoho/retry-confirm'
		|| location.pathname == '/shoho/resend/confirm'
	) {
		EPK.Uploader.bindPreviewEvent();
	}

	if (location.pathname == '/shoho/progress') {
		var urlExecute = EPK.Shoho.ARG.urlExecute;
		var urlFinish = EPK.Shoho.ARG.urlFinish;
		var reserveBundleId = EPK.Shoho.ARG.reserveBundleId;
		var reserveIds = EPK.Shoho.ARG.reserveIds;
		var pharmacyId = EPK.Shoho.ARG.pharmacyId;
		var memberFlag = EPK.Shoho.ARG.memberFlag;
		var pastReserveStatus = EPK.Shoho.ARG.pastReserveStatus;
		var optinMailmag = EPK.Shoho.ARG.optinMailmag;
		var Reserve = new EPK.Shoho.Reserve(urlExecute, urlFinish, reserveBundleId, reserveIds, pharmacyId, memberFlag, pastReserveStatus, optinMailmag);

		Reserve.execute();
	}

	if (location.pathname == '/shoho/finish'
		|| location.pathname == '/shoho/resend/finish'
	) {
		EPK.Shoho.Action.Finish.initialize();
	}

	if($('#shown_thumbnail_images_count').length > 0){
		shownThumbnailImagesCounter.updateShownImagesCount();
	}

	// おくすり手帳のメリットpopup
	var medbookModalLink = $('#medbook_modal_link');
	var medbookModal = $('#medbook_modal');
	if (medbookModalLink.length && medbookModal.length) {
		medbookModalLink.on('click', function() {
			$.magnificPopup.close();
			$.magnificPopup.open({
				items: {src: '#medbook_modal'},
				type: 'inline',
				modal: true,
			}, 0);
		});
	}
	$(".patientadd-btn").on("click",function(event){
		EPK.Shoho.Family.addFamily();
	});	
	if (location.pathname == '/shoho/prescription') {
		$('.patientdel-btn').on('click', function() {
			EPK.Shoho.Family.deletePatient(EPK.Shoho.ARG.pharmacyId, $(this).data('person-type'));
		});
	}
});
